import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const peopleProfilesRoute: InvariantJiraRoute = {
	name: 'people-index',
	path: '/jira/people/:subPath?',
};
